module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-main",
    style: ({
      minHeight: (_vm.screenHeight - 85) + 'px'
    })
  }, [_c('section', {
    staticClass: "user-section"
  }, [_c('div', {
    staticClass: "user__company"
  }), _vm._v(" "), _c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51b1c000"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User.vue
// module id = 1018
// module chunks = 1